import { Callout, CalloutProps } from "@blueprintjs/core";
import classNames from "classnames";
import React from "react";
import "./DetailPaneCallout.scss";

type DetailPaneCalloutProps = {
    readonly intent: CalloutProps["intent"];
    readonly title: string;
    readonly className?: string;
    readonly children: React.ReactNode;
};

const DetailPaneCallout: React.FC<DetailPaneCalloutProps> = ({
    intent,
    title,
    className,
    children
}) => (
    <Callout
        className={classNames("DetailPaneCallout", className)}
        intent={intent}
        title={title}
    >
        <p className="DetailPaneCallout-desc">{children}</p>
    </Callout>
);

export default DetailPaneCallout;
